









// import 'reflect-metadata'
import {Vue, Component, Prop} from 'vue-property-decorator'

@Component
export default class CardTitle extends Vue {
    @Prop() params!: object
    // pageTitle: string = "Profilo Utente"
}
